(() => {
  'use strict';

  const KLAVIYO_SITE_ID = 'U6rwVN';
  const KLAVIYO_REVISION = '2026-04-15';
  const KLAVIYO_ENDPOINT =
    'https://a.klaviyo.com/client/back-in-stock-subscriptions' +
    '?company_id=' +
    encodeURIComponent(KLAVIYO_SITE_ID);

  let lastTrigger = null;
  let isSubmitting = false;

  const getElements = () => {
    return {
      modal: document.querySelector('[data-mezuzah-bis-modal]'),
      form: document.querySelector('[data-mezuzah-bis-form]'),
      email: document.querySelector('[data-mezuzah-bis-email]'),
      variant: document.querySelector('[data-mezuzah-bis-variant]'),
      product: document.querySelector('[data-mezuzah-bis-product]'),
      submit: document.querySelector('[data-mezuzah-bis-submit]'),
      message: document.querySelector('[data-mezuzah-bis-message]')
    };
  };

  const resetFormState = (elements) => {
    if (elements.form) {
      elements.form.reset();
    }

    if (elements.message) {
      elements.message.textContent = '';
      elements.message.removeAttribute('data-status');
    }

    if (elements.submit) {
      elements.submit.disabled = false;
      elements.submit.textContent = 'Notify Me';
    }

    isSubmitting = false;
  };

  const openModal = (trigger) => {
    const elements = getElements();

    if (
      !elements.modal ||
      !elements.form ||
      !elements.email ||
      !elements.variant
    ) {
      return;
    }

    const variantId = trigger.getAttribute('data-variant-id');
    const productTitle =
      trigger.getAttribute('data-product-title') || 'this mezuzah';

    if (!variantId) {
      return;
    }

    lastTrigger = trigger;
    resetFormState(elements);

    elements.variant.value = variantId;

    if (elements.product) {
      elements.product.textContent = productTitle;
    }

    elements.modal.hidden = false;
    document.documentElement.classList.add('mezuzah-bis-open');

    window.requestAnimationFrame(() => {
      elements.modal.classList.add('is-open');
      elements.email.focus();
    });
  };

  const closeModal = () => {
    const elements = getElements();

    if (!elements.modal || elements.modal.hidden) {
      return;
    }

    elements.modal.classList.remove('is-open');
    document.documentElement.classList.remove('mezuzah-bis-open');

    window.setTimeout(() => {
      elements.modal.hidden = true;
      resetFormState(elements);

      if (lastTrigger) {
        lastTrigger.focus();
      }
    }, 200);
  };

  const displayMessage = (elements, text, status) => {
    if (!elements.message) {
      return;
    }

    elements.message.textContent = text;

    if (status) {
      elements.message.setAttribute('data-status', status);
    } else {
      elements.message.removeAttribute('data-status');
    }
  };

  const getApiError = async (response) => {
    try {
      const result = await response.json();

      if (
        result &&
        Array.isArray(result.errors) &&
        result.errors.length > 0 &&
        result.errors[0].detail
      ) {
        return result.errors[0].detail;
      }
    } catch (error) {
      // Klaviyo may return an empty or non-JSON error response.
    }

    return 'Something went wrong. Please try again.';
  };

  const submitBackInStockRequest = async (form) => {
    if (isSubmitting) {
      return;
    }

    const elements = getElements();
    const email = elements.email
      ? elements.email.value.trim()
      : '';
    const variantId = elements.variant
      ? elements.variant.value.trim()
      : '';

    if (!elements.email || !email || !elements.email.checkValidity()) {
      if (elements.email) {
        elements.email.reportValidity();
      }

      return;
    }

    if (!variantId) {
      displayMessage(
        elements,
        'We could not identify this product. Please open the product page and try again.',
        'error'
      );
      return;
    }

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    isSubmitting = true;

    if (elements.submit) {
      elements.submit.disabled = true;
      elements.submit.textContent = 'Submitting...';
    }

    displayMessage(elements, '', '');

    try {
      const response = await fetch(KLAVIYO_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          Accept: 'application/vnd.api+json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorMessage = await getApiError(response);
        throw new Error(errorMessage);
      }

      form.reset();

      displayMessage(
        elements,
        "You're all set. We'll let you know when it's back.",
        'success'
      );

      if (elements.submit) {
        elements.submit.disabled = true;
        elements.submit.textContent = "You're on the list";
      }
    } catch (error) {
      displayMessage(
        elements,
        error && error.message
          ? error.message
          : 'Something went wrong. Please try again.',
        'error'
      );

      if (elements.submit) {
        elements.submit.disabled = false;
        elements.submit.textContent = 'Notify Me';
      }

      isSubmitting = false;
    }
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest(
      '[data-mezuzah-bis-open]'
    );

    if (openTrigger) {
      event.preventDefault();
      openModal(openTrigger);
      return;
    }

    const closeTrigger = event.target.closest(
      '[data-mezuzah-bis-close]'
    );

    if (closeTrigger) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-mezuzah-bis-form]')) {
      return;
    }

    event.preventDefault();
    submitBackInStockRequest(event.target);
  });

  document.addEventListener('keydown', (event) => {
    const elements = getElements();

    if (
      event.key === 'Escape' &&
      elements.modal &&
      !elements.modal.hidden
    ) {
      closeModal();
    }
  });
})();